import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import { getLineItemTreatedByLogisticianQuantity } from "./get-line-item-treated-by-logistician-quantity";

export type GetLineItemNotTreatedParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has not been treated
 * by the logistician or the merchant yet.
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 3 white t-shirt.
 * The merchant has validated 1 white t-shirt.
 * The logistician has rejected 1 white t-shirt.
 *
 * This function would simply return 1 (item left to be treated)
 */
export function getLineItemNotTreatedByLogisticianQuantity({
  lineItem,
}: GetLineItemNotTreatedParams) {
  const quantityTreatedByLogistician = getLineItemTreatedByLogisticianQuantity({
    lineItem,
    withMerchantTreated: true,
  });

  /**
   * We use Math.max because some items might have been treated by both the logistician and the merchant.
   */
  return Math.max(0, lineItem.quantity - quantityTreatedByLogistician);
}
